namespace TabAurous.Sales {
    export interface SalesReturnMasterRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        RoundOff?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: SalesReturnItemsRow[];
        TaxDetails?: SalesReturnTaxRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace SalesReturnMasterRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Sales.SalesReturnMaster';
        export const deletePermission = 'Sales:Return:Delete';
        export const insertPermission = 'Sales:Return:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Return:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            RoundOff = "RoundOff",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
